import { Component, OnInit, Inject } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmpInfo } from '../model/emp.model';
import { UserLoginInfo } from '../model/userlogin.model';
import { ProjectInfo } from '../model/project.model';
import { ProjectMemberInfo } from '../model/projectmember.model';
import {
  environment
} from 'src/environments/environment';

import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { sha256, sha224 } from 'js-sha256';
import { TokenService } from '../service/token.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-password-expire',
  templateUrl: './user-password-expire.component.html',
  styleUrls: ['./user-password-expire.component.css']
})
export class PasswordExpireComponent implements OnInit {
  form: FormGroup;
  titlemodal: string
  detailmodal: string
  baseurl: string;
  _ParamEmpCode: string;
  _ParamEmail: string;

  hide = true;
  Chide = true;
  EmpList: EmpInfo[]
  UserloginList: EmpInfo[] = [];
  ProjectList: ProjectInfo[]
  ProjectMemberList: ProjectMemberInfo[]

  subscriptionLoadEmpList: Subscription
  subscriptionLoadUserloginList: Subscription
  subscriptionLoadProjectList: Subscription
  subscriptionLoadProjectMemberList: Subscription
  // Emp Detail Zone
  txtEmployeeCode: string;
  txtTitle: string;
  txtFirstName: string;
  txtLastName: string;
  txtPosition: string;
  txtTeam: string;
  txtRole: string;

  txtNew: string;
  flagduplicate: boolean;
  flagpasswordconfirm: boolean;

  hidUserLoginId: number
  hidEmpCodeUpdatePermissionProject: string
  hidUsernameUpdatePermissionProject: string
  hidEmailUpdatePermissionProject: string

  //isOnUpdate: boolean;
  isSubmitted: any;
  arrayelement: any;
  isUserSubmitted: boolean = false;

  readonlyUseranme: string;
  readonlyEmail: string;

  Email: string;
  Password: string;
  ConfirmPassword: string;

  //Token
  appId: string;
  getTokenUrl: string;
  UserType: string;

  
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private router: ActivatedRoute, private TokenService: TokenService, private routers: Router) {
    this.UserType = localStorage.getItem("UserType");
    this.baseurl = environment.base_api;
    this.appId = environment.appId;//this.UserType == "INTERNAL" ? "JOINSPLUS" : environment.appId;
  }
  ngOnInit() {
    this.arrayelement = [];
    this.txtNew = "";

    //Set param
    this.router.params.subscribe(params => {
      this._ParamEmpCode = params['EmpCode'];
      this._ParamEmail = params['Email'];
      this.Email = params['Email'];

      localStorage.setItem("email", params['Email']);
      localStorage.setItem('EmpMail', params['Email']);
    });

    this.LoadUserLoginList();

    this.form = this.formBuilder.group({
      Email: [null],
      Password: [
        null,
        [
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/g
          ),
          Validators.minLength(8),
        ],
      ],
      ConfirmPassword: [
        null,
        [
          Validators.pattern(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/g
          ),
          Validators.minLength(8),
        ],
      ],

    });
  }

  goToVotes($myParam: string = ''): void {
    const navigationDetails: string[] = ['/portal'];
    if ($myParam.length) {
      navigationDetails.push($myParam);
    }
    
    this.routers.navigate(navigationDetails).then(() => {
      window.location.reload();
    });
  }

  LoadUserLoginList() {

    var that = this;
    this.subscriptionLoadUserloginList = this.LoadUserLogin()
      .subscribe({
        next: data => {
          
          this.subscriptionLoadUserloginList.unsubscribe();
          this.UserloginList = data;
          var item = data[0];
          localStorage.setItem("EmpCode", item.EmpCode);
          localStorage.setItem("UserName", item.Mail);
          localStorage.setItem("EmpName_TH", item.EmpName_TH);
          localStorage.setItem("EmpFName_EN", item.EmpFname_EN);
          localStorage.setItem("EmpRoleCode", item.RoleCode);
          localStorage.setItem("EmpMail", item.Mail);
          localStorage.setItem("ExpireDate", item.ExpireDate);
          localStorage.setItem("UpdateDate", item.UpdateDate);
          localStorage.setItem("CompanyCode", item.CompanyCode);
          localStorage.setItem("CompanyName", item.CompanyName);
        },
        error: error => {
          
          console.error('There was an error!', error);
        }
      });
  }

  LoadEmpDetail(auth_token): Observable<EmpInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this._ParamEmpCode);
    objectjson['Email'] = this.checkUndefinedString(this._ParamEmail);
    let strjson = JSON.stringify(objectjson);


    return this.httpClient
      .post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria",
        strjson, httpOptions)


  }

  LoadUserLogin(): Observable<EmpInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this._ParamEmpCode);
    objectjson['Email'] = this._ParamEmail;
    objectjson['UserType'] = this.UserType;
    let strjson = JSON.stringify(objectjson);


    return this.httpClient
      .post<EmpInfo[]>(this.baseurl + "UserLogin/getUserLogin",
        strjson, httpOptions)
  }

  btnClick_onUpdateUserLogin() {
    this.isUserSubmitted = true;
    $('#ModalUserLogin').modal('hide');
    this.txtNew = "New";
    $('#ModalUserLogin').modal();

  }

  async btnClick_submitUpdateUserLogin() {

    debugger

    if (this.form.valid && this.flagpasswordconfirm == false) {
      let auth_token = await this.TokenService.GetToken(this.Email, (this.UserloginList[0].Password), this.appId).then(response => {
        if (!response.isError) {

          localStorage.setItem("refreshToken", response.data.refreshToken);//auth token
          localStorage.setItem("token", response.data.token);

          return response.data.token;
        } else {
          return "";
        }
      }).catch(err => {
        return "";
      });
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['EmpCode'] = this._ParamEmpCode;
        objectjson['Password'] = sha256(this.checkUndefinedString(this.form.controls['Password'].value));
        //objectjson['Password'] = sha256(this.checkUndefinedString(this.Password));
        objectjson['Email'] = this._ParamEmail;
        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['UserType'] = this.checkUndefinedString(localStorage.getItem("UserType"));

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<UserLoginInfo[]>(this.baseurl + "UserLogin/UpdateForgotPassword", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdatingUserLogin('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdatingUserLogin('n');
              $('#ModalUpdateComplate').modal();
              
              this.LoadUserLoginList();
            }
          )

        return true;

      } else {
        return false;
      }
    } else {
      this.validateAllFormFields(this.form);
    }



  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxUserLogin"]').prop('checked', check);

  }
 
  ClearinputUserLogin() {
    this.form.patchValue({
      Username: "",
      Email: "",
      Password: "",
      ConfirmPassword: "",
    });
  }

  OnUpdatingUserLogin(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitUserLogin").hide();
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitUserLogin").show();
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalUserLogin').modal('hide');
    }

  }

  CheckduplicateUserLogin() {

    var Email = this._ParamEmail;
    let index = !!this.UserloginList ? this.UserloginList.findIndex(x => x.Mail == Email) : -1;
    var flagreturn = false;
    if (index != -1) {
      flagreturn = true;
    }
    this.flagduplicate = flagreturn;
    return flagreturn;
  }

  CheckConfirmPassword() {
    var password = this.form.controls['Password'].value;
    var confirmpassword = this.ConfirmPassword;
    if (password != confirmpassword) {
      this.flagpasswordconfirm = true;

    } else {
      this.flagpasswordconfirm = false;
    }

    return this.flagpasswordconfirm;
  }

  isFieldValid(field: string) {

    return this.isUserSubmitted && !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }

  ConvertDate(DateValue) {
    if (DateValue) {

      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daystr = '';

      if (day < 10) {
        daystr = '0' + day
      } else {
        daystr = day.toString();
      }


      var monthIndex = date.getMonth() + 1;
      var monthstr = '';

      if (monthIndex < 10) {
        monthstr = '0' + monthIndex
      } else {
        monthstr = monthIndex.toString();
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Hoursstr = '';
      var Minutesstr = '';

      if (Hours < 10) {
        Hoursstr = '0' + Hours
      } else {
        Hoursstr = Hours.toString();
      }
      if (Minutes < 10) {
        Minutesstr = '0' + Minutes
      } else {
        Minutesstr = Minutes.toString();
      }
      var Datenow = '';

      Datenow = monthstr + "/" + daystr + "/" + year + " " + Hoursstr + ":" + Minutesstr;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }

  RedirectToPortal() {
    window.location.href = '/portal' //ใช้อันนี้เพราะอยากให้ Reload เอา style web มาใหม่ด้วย
  }

  //OAuth 2
  AuthorizeUser(txtEmpCode) {
    //Open new tab to do OAuth2
    this.getTokenUrl = this.TokenService.GetAccessTokenUrl(txtEmpCode);
    window.open(this.getTokenUrl, "_blank");

  }
}
